export enum BonusType {
    KYCBonus = 0
}